import { render, staticRenderFns } from "./ChartBarNotation.vue?vue&type=template&id=35ea9890&"
import script from "./ChartBarNotation.vue?vue&type=script&lang=js&"
export * from "./ChartBarNotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports